module.exports = __webpack_public_path__ + "img/mt.a2a741b4.jpg";